import React from "react";

const Faq = () => {
  const faqs = [
    {
      question: "How much does your service cost?",
      answer:
        "Pricing varies depending on the specifics of each case, we are unique in this service and we offer competitive rates with no hidden fees. Reach out, and we’ll provide a quote.",
    },
    {
      question: "What if I have numerous complaints, will I get a discount?",
      answer:
        "If you know you have a persistent problem, and you know you will be submitting numerous claims, you can use out monthly subscription service.",
    },
    {
      question: "How long does it take to resolve a case?",
      answer:
        "Most cases are resolved within a few weeks. We keep you updated throughout the process, so you’ll always know where things stand.",
    },
    {
      question: "Will the driver know I reported them?",
      answer:
        "No, we handle all communication with the vehicle owner professionally and discreetly.",
    },
    {
      question: "What if the same vehicle parks again?",
      answer:
        "If the same vehicle repeatedly parks on your pavement, contact us, and we’ll review the case. We aim to provide a long-term solution.",
    },

  ];

  return (
    <div className="relative w-full bg-white px-6 pt-10 pb-8 mt-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-2xl sm:rounded-lg sm:px-10">
      <div className="mx-auto px-5">
        <div className="flex flex-col items-center">
          <h2 className="mt-5 text-center text-3xl font-bold tracking-tight md:text-5xl">
            FAQ
          </h2>
          <p className="mt-3 text-lg text-neutral-500 md:text-xl">
            Frequently asked questions
          </p>
        </div>
        <div className="mx-auto mt-8 grid max-w-xl divide-y divide-neutral-200">
          {faqs.map((faq, index) => (
            <div key={index} className="py-5">
              <details className="group">
                <summary className="flex cursor-pointer list-none items-center justify-between font-medium">
                  <span>{faq.question}</span>
                  <span className="transition group-open:rotate-180">
                    <svg
                      fill="none"
                      height="24"
                      shapeRendering="geometricPrecision"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                <p className="group-open:animate-fadeIn mt-3 text-neutral-600">
                  {faq.answer}
                </p>
              </details>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
